import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../Icon';
import { uploadFile } from '../../../actions';
import FileUpload from '../../../utils/FileUpload';
import {
  InputOrderFormDate
} from './';

var AppConfig = require('../../../config.json');

/**
 * A simple InputOrderFormCheckboxSupport.
 */


class InputOrderFormCheckboxSupport extends React.Component {
	constructor(props) {
	  super(props);
		this.handleToggleClick = this.handleToggleClick.bind(this);
		this.handleUpload = this.handleUpload.bind(this);
		this.handleValidUntilChange = this.handleValidUntilChange.bind(this);
		this.checkForUploadStatus = this.checkForUploadStatus.bind(this);
	  this.state = {active:false, init:false, validUntil: false, validDate: 0, isUploading: false};
	}
	componentDidMount() {
		if(this.props.selected) {
			this.setState({active:true});
		}
		this.setState({init:true});
	}

	componentWillUpdate(nextProps, nextState) {
		if(nextProps.upload.isSuccess && !this.props.upload.isSuccess && nextProps.upload.type===this.props.type) {
			if(this.props.addValidUntil) {
				if(!this.state.validUntil) {
					return;
				}
			}
			this.props.addUpload(nextProps.upload.path, this.props.type, this.state.validDate);
		}
	}


	handleToggleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(this.props.type, nextState, this.props.alreadyUploaded);
	}
	handleUpload(file) {
		if(this.props.upload.isUploading) {
			return;
		}
		if(this.props.addValidUntil) {
			if(!this.state.validUntil) {
				return;
			}
		}

		if(this.refs.fileupload.state.isUploading) {
			this.setState({isUploading:!this.state.isUploading});
		}
		
		var formdata = new FormData();
		formdata.append('files', file);
        this.props.dispatch(uploadFile(formdata, this.props.type, this.state.validDate));
        
		
	}

	handleValidUntilChange(targ, hasError, itemkey) {
		this.setState({validUntil:!hasError, validDate: targ.value});
	}

	checkForUploadStatus() {
		if(this.props.upload.isUploading && this.props.upload.type===this.props.type) {
			// console.log('is uploading')
			return true;
		}
		return false;
	}

    render () {
        return (
          <div className={`orderformcheckbox${this.state.active?" selected":""}${this.props.addValidUntil?" addvalid":""}${this.state.validUntil?" valid":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleToggleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className={`desc${AppConfig.supportTypes[this.props.type].desc!==''?'':' empty'}`}>
            		<h4>{AppConfig.supportTypes[this.props.type].label}</h4>
            		{AppConfig.supportTypes[this.props.type].desc!==''?
            			<div className="subline" style={{color:"black"}}>
		              		{AppConfig.supportTypes[this.props.type].desc}
		              	</div>
		              	:null
            		}
	            	{this.props.addValidUntil && !this.props.alreadyUploaded?
	            		<div className={`validContainer${this.state.active?" active":""}`}>
		            		{this.state.isUploading?<div className="coverup"></div>:null}
		            		<InputOrderFormDate
					            ref="validuntil"
					            name="validuntil"
					            itemkey="validuntil"
					            verify="date"
					            label="Förderung gültig bis"
					            value={this.props.validUntil}
					            required={true}
					            onChange={this.handleValidUntilChange}
					          />
	            		</div>
	            		:null
	            	}
            	</div>
            	{!this.props.alreadyUploaded?
            		!this.props.addValidUntil || (this.props.addValidUntil && this.state.validUntil)?
	            	<div className={`uploadarea${this.props.addValidUntil?" validUntil":""}${this.props.addValidUntil && this.state.validUntil?" validDateCorrect":""}`}>
	            		<FileUpload ref="fileupload" active={this.state.active} isUploading={this.checkForUploadStatus()} handleUpload={this.handleUpload} headline={`Upload Bescheinigung ${AppConfig.supportTypes[this.props.type].label}`} />
		            </div>
		            : <div className={`uploadareahint${this.state.active?" active":""}`}>
		            	Bitte tragen Sie vor dem Hochladen Ihres Nachweises das Gültigkeit-Datum ein.
		            	</div>
		            :
		            <div className="alreadyUploaded">Der Nachweis wurde erfolgreich hochgeladen.</div>
	        	}
            </div>

          </div>
        );
    }

}


InputOrderFormCheckboxSupport.propTypes = {
	
	/** InputOrderFormCheckboxSupport selected */
	selected: PropTypes.bool,
	/** InputOrderFormCheckboxSupport Label */
	type: PropTypes.string.isRequired,
	alreadyUploaded: PropTypes.bool,
	addValidUntil: PropTypes.bool,
}


InputOrderFormCheckboxSupport.defaultProps = {
  selected: false,
  alreadyUploaded: false,
  addValidUntil: false,
  type: ""
}

const mapStateToProps = (state) => {
  return {
    upload: state.upload
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputOrderFormCheckboxSupport)



// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormCheckboxSupport.js